var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquipamentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23471 3.54509C4.14762 3.54509 3.26637 4.42634 3.26637 5.51342V28.3826C3.26637 29.4697 4.14762 30.3509 5.23471 30.3509H28.1039C29.1909 30.3509 30.0722 29.4697 30.0722 28.3826V5.51342C30.0722 4.42634 29.1909 3.54509 28.1039 3.54509H5.23471ZM0.585785 5.51342C0.585785 2.94589 2.66718 0.864502 5.23471 0.864502H28.1039C30.6714 0.864502 32.7528 2.94589 32.7528 5.51342V28.3826C32.7528 30.9501 30.6714 33.0315 28.1039 33.0315H5.23471C2.66718 33.0315 0.585785 30.9501 0.585785 28.3826V5.51342Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6402 17.4091C26.6402 18.4784 26.0105 19.4006 25.1015 19.8251V20.8698C25.1015 21.1129 24.9042 21.3102 24.6611 21.3102H23.2888C23.0457 21.3102 22.8484 21.1129 22.8484 20.8698V19.8251C21.9394 19.4006 21.3096 18.4784 21.3096 17.4091C21.3096 16.3398 21.9394 15.4167 22.8484 14.9922V13.9485C22.8484 13.7045 23.0457 13.5081 23.2888 13.5081H24.6611C24.9042 13.5081 25.1015 13.7045 25.1015 13.9485V14.9922C26.0105 15.4167 26.6402 16.3389 26.6402 17.4091Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.73328,
    y: 6.72137,
    width: 15.8728,
    height: 4.2195,
    rx: 1.34029,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipamentIcon);
export default __webpack_public_path__ + "static/media/EquipamentIcon.fbe8b5674acc7b0d4f9b276bdad14524.svg";
export { ForwardRef as ReactComponent };